import { createFocusTrap } from 'focus-trap'
import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class MenuBarComponent extends Component {
  init() {
    this.container = this.element.querySelector('.menu-bar__container')
    this.dialog = this.element.querySelector('.menu-bar__dialog')
    this.buttonMenu = this.element.querySelector('.button--open-menu-dialog')
    this.buttonClose = this.element.querySelector('.button--close-menu-dialog')

    if (!this.container || !this.dialog || !this.buttonMenu || !this.buttonClose) {
      return
    }

    this.dialogIsOpen = false
    this.contentContainers = [...document.querySelectorAll('.container--content, .container--footer')]
    this.firstFocusableItem = this.dialog.querySelector('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')

    this.focusTrap = createFocusTrap(this.dialog, {
      onActivate: () => {},
      onDeactivate: () => {
        this.buttonMenu.focus()
      },
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: true,
      initialFocus: this.firstFocusableItem || false,
    })

    this.buttonMenu.addEventListener('click', () => this.toggleDialog())
    this.buttonClose.addEventListener('click', () => this.toggleDialog(true))
    window.addEventListener('resize', () => !this.dialogIsOpen || this.toggleDialog(true))

    this.initPeekabooOnScroll()
  }

  toggleDialog(forceClose = false) {
    if (!this.dialog) {
      return
    }

    if (this.dialogIsOpen || forceClose) {
      this.dialogIsOpen = false
      this.focusTrap?.deactivate()
      this.dialog.close()
      window.dispatchEvent(new CustomEvent('close-navigation-dropdown-expanders'))
      document.documentElement.classList.remove('prevent-scrolling')
      this.contentContainers.forEach(container => container.removeAttribute('inert'))
    } else {
      this.contentContainers.forEach(container => container.setAttribute('inert', 'inert'))
      document.documentElement.classList.add('prevent-scrolling')
      this.dialog.show()
      this.focusTrap?.activate()
      this.dialogIsOpen = true
    }
  }

  initPeekabooOnScroll() {
    this.allowEffect = false
    this.lastScrollPosition = 0
    this.scrollThreshold = 5
    this.minScrollDistance = 100
    this.timeoutDelay = 250
    this.timeout = null

    this.container.classList.remove('menu-bar__container--peekaboo')
    window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => (this.allowEffect = true))

    document.addEventListener('scroll', () => this.onScrollHandler(), { passive: true })
  }

  onScrollHandler() {
    const currentScrollPosition = window.scrollY

    if (!this.allowEffect || Math.abs(currentScrollPosition - this.lastScrollPosition) < this.scrollThreshold) {
      return
    }

    this.container.classList.toggle('menu-bar__container--peekaboo', currentScrollPosition > this.lastScrollPosition && currentScrollPosition > this.minScrollDistance)
    this.lastScrollPosition = currentScrollPosition
    this.allowEffect = false

    window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => (this.allowEffect = true))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'menu-bar', MenuBarComponent))
